const DEFAULT_LOCALE = 'en-US'

export const formatNumber = (number: number) => {
  return new Intl.NumberFormat(DEFAULT_LOCALE).format(number)
}
